import React, { Component } from "react";
import PropTypes from "prop-types";

import styles from "./HeaderDropdownItem.css";
import Icon from "components/library/Icon";
import { Link } from "react-router-dom";

export default class HeaderDropdownItem extends Component {
  render() {
    return (
      <li className={styles.root}>
        <Link
          className={styles.link}
          to={this.props.to}
          data-cy={this.props.to}
        >
          {this.props.icon ? (
            <Icon name={this.props.icon} className={styles.icon} />
          ) : null}
          {this.props.children}
        </Link>
      </li>
    );
  }
}

HeaderDropdownItem.propTypes = {
  icon: PropTypes.string,
  to: PropTypes.string.isRequired,
};
